import script from "./ResizeObserver.vue?vue&type=script&lang=ts"
export * from "./ResizeObserver.vue?vue&type=script&lang=ts"

const __exports__ = script;

export default __exports__